import { useQuery } from 'react-query';

import { axios } from 'lib';

const getLotSuppliers = (frameworkAgreementId, lotId) => {
  return axios.get(`/api/framework_agreements/${frameworkAgreementId}/setup/lots/${lotId}/suppliers`);
};

export const useLotSuppliers = (frameworkAgreementId, lotId, options = {}) => {
  return useQuery(
    `framework_agreements-${frameworkAgreementId}-lot-${lotId}-suppliers`,
    () => getLotSuppliers(frameworkAgreementId, lotId),
    {
      select: ({ data }) => data.data,
      ...options,
    }
  );
};
